module.exports = __webpack_public_path__ + "static/bubble-game-d526799b66d040560695af3e1de640fc.jpg";